import { api2 } from './api';

export async function fetchCoachQueue(coachId) {
  const params = coachId ? `?coach_id=${coachId}` : '';
  const { data } = await api2.get(`training_plan_requests/coach-queue${params}`);
  return data;
}

export async function fetchSuggestion(requestId) {
  const { data } = await api2.get(`training_plan_requests/${requestId}/suggestion`);
  return data;
}

export async function approveSuggestion(requestId) {
  const { data } = await api2.post(`training_plan_requests/${requestId}/approve-suggestion`);
  return data;
}

export async function rejectSuggestion(requestId, reason) {
  const { data } = await api2.post(`training_plan_requests/${requestId}/reject-suggestion`, { reason });
  return data;
}

export async function completeReview(requestId, payload) {
  const { data } = await api2.post(`training_plan_requests/${requestId}/complete-review`, payload);
  return data;
}

export async function fetchMatchingDashboard() {
  const { data } = await api2.get('training_plan_requests/matching-dashboard');
  return data;
}

export async function fetchAdminRequests({ page = 1, status = 'all', coachId, withoutCoach, autoApplyFilter } = {}) {
  const params = new URLSearchParams({ page: String(page), status });
  if (coachId !== undefined && coachId !== null && coachId >= 0) {
    params.set('coachId', String(coachId));
  }
  if (withoutCoach) {
    params.set('withoutCoach', 'true');
  }
  if (autoApplyFilter) {
    params.set('autoApplyFilter', autoApplyFilter);
  }
  const { data } = await api2.get(`training_plan_requests/admin/list?${params.toString()}`);
  return data;
}

export async function updateRequest(requestId, payload) {
  const { data } = await api2.put(`training_plan_requests/${requestId}`, payload);
  return data;
}

export async function fetchRequestsByUserId(userId, page = 1) {
  const { data } = await api2.get(`training_plan_requests?userId=${userId}&page=${page}`);
  return data;
}

export async function fetchRequestsByEmail(email) {
  const { data } = await api2.get(`training_plan_requests?email=${encodeURIComponent(email)}`);
  return data;
}
